import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { LoaderComponent } from '@progress/kendo-angular-indicators';
import { SignInCallback, SignOutCallback } from '@store/auth/auth.actions';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-callback',
  imports: [LoaderComponent],
  templateUrl: './callback.component.html',
})
export class CallbackComponent implements OnInit, OnDestroy {

  private _unsubsribeAll = new Subject<void>();

  constructor(private store: Store, private router: Router) { }

  ngOnInit(): void {
    const isLogout = this.router.url.includes('signout-callback');
    const action = isLogout ? new SignOutCallback() : new SignInCallback();
    this.store.dispatch(action).pipe(
      takeUntil(this._unsubsribeAll)
    ).subscribe(() => this.store.dispatch(new Navigate(['station'])));
    // we might need to change this to track the URL - but TBD
  }

  ngOnDestroy(): void {
    this._unsubsribeAll.next();
    this._unsubsribeAll.complete();
  }
}
